import {
  CLEAR_TRANSACTIONS,
  CLEAR_TRANSACTION,
  CLEAR_STATE,

  DELETE_TRANSACTION,
  DELETE_TRANSACTION_ERROR,
  DELETE_TRANSACTION_SUCCESS,

  DOWNLOAD_TRANSACTIONS,
  DOWNLOAD_TRANSACTIONS_ERROR,
  DOWNLOAD_TRANSACTIONS_SUCCESS,

  GET_TRANSACTION,
  GET_TRANSACTION_ERROR,
  GET_TRANSACTION_SUCCESS,

  GET_INVOICE,
  GET_INVOICE_ERROR,
  GET_INVOICE_SUCCESS,

  GET_TRANSACTIONS,
  GET_TRANSACTIONS_ERROR,
  GET_TRANSACTIONS_SUCCESS,

  GET_ALL_TRANSACTIONS,
  GET_ALL_TRANSACTIONS_ERROR,
  GET_ALL_TRANSACTIONS_SUCCESS,

  SAVE_TRANSACTION,
  SAVE_TRANSACTION_ERROR,
  SAVE_TRANSACTION_SUCCESS,

  DUPLICATE_TRANSACTION,
  DUPLICATE_TRANSACTION_ERROR,
  DUPLICATE_TRANSACTION_SUCCESS,

  CHANGE_DATE_TRANSACTION,
  CHANGE_DATE_TRANSACTION_ERROR,
  CHANGE_DATE_TRANSACTION_SUCCESS,

  MASS_DELETE_TRANSACTION,
  MASS_DELETE_TRANSACTION_ERROR,
  MASS_DELETE_TRANSACTION_SUCCESS,

  TRANSFER_TRANSACTION,
  TRANSFER_TRANSACTION_ERROR,
  TRANSFER_TRANSACTION_SUCCESS,

  GET_ACCOUNTS_WITH_TOTAL,
  GET_ACCOUNTS_WITH_TOTAL_ERROR,
  GET_ACCOUNTS_WITH_TOTAL_SUCCESS,

  CREATE_TRANSACTIONS,
  CREATE_TRANSACTIONS_ERROR,
  CREATE_TRANSACTIONS_SUCCESS,

  CREATE_PAYMENT_TRANSACTION,
  CREATE_PAYMENT_TRANSACTION_ERROR,
  CREATE_PAYMENT_TRANSACTION_SUCCESS,

  UPDATE_COOWNER_CONTACT,
  UPDATE_COOWNER_CONTACT_ERROR,
  UPDATE_COOWNER_CONTACT_SUCCESS,

  GET_TRANSACTION_USER,
  GET_TRANSACTION_USER_ERROR,
  GET_TRANSACTION_USER_SUCCESS,

} from './constants';

export default {
  [CLEAR_TRANSACTIONS](state) {
    state.error = false;
    state.success = false;
    state.exportSuccess = false;
    state.exportLoading = false;
    state.loading = false;
    state.preventNew = false;
    state.transactions = [];
    state.allTransactions = [];
    state.transaction = false;
    state.accountsWithTotal = false;
  },
  [CLEAR_TRANSACTION](state) {
    state.transaction = {
      date: null,
      paid: false,
      description: null,
      note: null,
      amount: null,
      categoryID: '',
      syndicateID: null,
      accountID: null,
      accountName: null,
    };
  },

  [CLEAR_STATE](state) {
    state.error = false;
    state.success = false;
  },

  [DELETE_TRANSACTION](state) {
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [DELETE_TRANSACTION_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [DELETE_TRANSACTION_SUCCESS](state) {
    state.success = true;
    state.transaction = false;
    state.loading = false;
  },

  [DOWNLOAD_TRANSACTIONS](state) {
    state.downloadLink = '';
    state.exportSuccess = false;
    state.error = false;
    state.exportLoading = true;
  },
  [DOWNLOAD_TRANSACTIONS_ERROR](state, payload) {
    state.error = payload;
    state.exportLoading = false;
  },
  [DOWNLOAD_TRANSACTIONS_SUCCESS](state, payload) {
    state.downloadLink = payload;
    state.exportLoading = false;
    state.exportSuccess = true;
  },

  [GET_TRANSACTION](state) {
    state.transaction = false;
    state.error = false;
    state.loading = true;
  },
  [GET_TRANSACTION_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_TRANSACTION_SUCCESS](state, payload) {
    state.transaction = payload;
    state.loading = false;
  },

  [GET_INVOICE](state) {
    state.downloadLink = '';
    state.exportSuccess = false;
    state.error = false;
    state.exportLoading = true;
  },
  [GET_INVOICE_ERROR](state, payload) {
    state.error = payload;
    state.exportLoading = false;
  },
  [GET_INVOICE_SUCCESS](state, payload) {
    state.downloadLink = payload;
    state.exportLoading = false;
    state.exportSuccess = true;
  },

  [GET_TRANSACTIONS](state) {
    state.error = false;
    state.loading = true;
  },
  [GET_TRANSACTIONS_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_TRANSACTIONS_SUCCESS](state, payload) {
    state.transactions = payload.data;
    state.paging = payload.paging;
    state.loading = false;
  },

  [GET_ALL_TRANSACTIONS](state) {
    state.error = false;
    state.loading = true;
  },
  [GET_ALL_TRANSACTIONS_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_ALL_TRANSACTIONS_SUCCESS](state, payload) {
    state.allTransactions = payload.data;
    state.loading = false;
  },

  [SAVE_TRANSACTION](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [SAVE_TRANSACTION_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.formLoading = false;
  },
  [SAVE_TRANSACTION_SUCCESS](state, payload) {
    if (payload.rowIndex) {
      state.transactions.splice(payload.rowIndex, 1, payload.transaction);
    } else {
      state.transactions.unshift(payload.transaction);
    }
    state.preventNew = false;
    state.success = true;
    state.formLoading = false;
  },

  [DUPLICATE_TRANSACTION](state) {
    state.error = false;
    state.success = false;
    state.loading = true;
  },
  [DUPLICATE_TRANSACTION_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.loading = false;
  },
  [DUPLICATE_TRANSACTION_SUCCESS](state) {
    state.success = true;
    state.loading = false;
  },

  [CHANGE_DATE_TRANSACTION](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [CHANGE_DATE_TRANSACTION_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.formLoading = false;
  },
  [CHANGE_DATE_TRANSACTION_SUCCESS](state) {
    // state.transactions.splice(0, 1, payload);
    state.success = true;
    state.formLoading = false;
  },

  [MASS_DELETE_TRANSACTION](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [MASS_DELETE_TRANSACTION_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.formLoading = false;
  },
  [MASS_DELETE_TRANSACTION_SUCCESS](state) {
    state.success = true;
    state.formLoading = false;
  },

  [TRANSFER_TRANSACTION](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [TRANSFER_TRANSACTION_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.formLoading = false;
  },
  [TRANSFER_TRANSACTION_SUCCESS](state) {
    state.success = true;
    state.formLoading = false;
  },

  [GET_ACCOUNTS_WITH_TOTAL](state) {
    state.accountsWithTotal = false;
    state.error = false;
    state.loading = true;
  },
  [GET_ACCOUNTS_WITH_TOTAL_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_ACCOUNTS_WITH_TOTAL_SUCCESS](state, payload) {
    state.accountsWithTotal = payload;
    state.loading = false;
  },

  [CREATE_TRANSACTIONS](state) {
    state.error = false;
    state.success = false;
    state.loading = true;
    state.transactionsCreated = 0;
  },
  [CREATE_TRANSACTIONS_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.loading = false;
  },
  [CREATE_TRANSACTIONS_SUCCESS](state, payload) {
    state.success = true;
    state.loading = false;
    state.transactionsCreated = payload.transactionsCreated;
  },

  [CREATE_PAYMENT_TRANSACTION](state) {
    state.error = false;
    state.success = false;
    state.loading = true;
  },
  [CREATE_PAYMENT_TRANSACTION_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.loading = false;
  },
  [CREATE_PAYMENT_TRANSACTION_SUCCESS](state) {
    state.success = true;
    state.loading = false;
  },

  [UPDATE_COOWNER_CONTACT](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [UPDATE_COOWNER_CONTACT_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.formLoading = false;
  },
  [UPDATE_COOWNER_CONTACT_SUCCESS](state, payload) {
    // state.transactions.splice(0, 1, payload);
    state.success = true;
    state.formLoading = false;
    state.coownerUser = payload;
  },
  [GET_TRANSACTION_USER](state) {
    state.transactionUser = false;
    state.error = false;
    state.loading = true;
  },
  [GET_TRANSACTION_USER_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_TRANSACTION_USER_SUCCESS](state, payload) {
    state.transactionUser = payload;
    state.loading = false;
  },

  // single object item mutation
  updateItem(state, payload) {
    state.transaction[payload.item] = payload.value;
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Transactions/mutations.js